import {apiHttpClient} from "@/http/httpClient";
import type {RateGroup, RateGroupListRequest} from "@/models/rate-group/rate-group";
import type {PaginationItems} from "@/models/pagination";
import type {RateGroupSegment} from "@/models/rate-group/rate-group-segment";
import {
  ListRelationsOfRateGroupModel,
  ListRelationsOfRateGroupRequest
} from "@/models/rate-group/rate-group";

const ENDPOINT_GET_RATE_GROUPS = 'RateGroup/GetRateGroups';
const ENDPOINT_GET_RATE_GROUP = 'RateGroup/GetRateGroup';
const ENDPOINT_CREATE_RATE_GROUP = 'RateGroup/CreateRateGroup';
const ENDPOINT_UPDATE_RATE_GROUP = 'RateGroup/UpdateRateGroup';
const ENDPOINT_DELETE_RATE_GROUP = 'RateGroup/DeleteRateGroup';
const ENDPOINT_GET_RATE_GROUP_SEGMENTS = 'RateGroup/GetRateGroupSegments';
const ENDPOINT_LIST_RELATIONS_OF_RATEGROUP = "RateGroup/ListRelations";

export const getRateGroups = async (request: RateGroupListRequest) => {
  return apiHttpClient().post<PaginationItems<RateGroup>>(ENDPOINT_GET_RATE_GROUPS, request)
    .then(response => response)
    .catch(error => error);
}

export const getRateGroup = async (id: number) => {
    return apiHttpClient().get<RateGroup>(`${ENDPOINT_GET_RATE_GROUP}/${id}`)
      .then(response => response)
      .catch(error => error);
}
export const createRateGroup = async (request: RateGroup) => {
    return apiHttpClient().post(ENDPOINT_CREATE_RATE_GROUP, request)
      .then(response => response)
      .catch(error => error);
}

export const updateRateGroup = async (request: RateGroup) => {
    return apiHttpClient().put(ENDPOINT_UPDATE_RATE_GROUP, request)
      .then(response => response)
      .catch(error => error);
}

export const deleteRateGroup = async (id: number) => {
  return apiHttpClient().delete(`${ENDPOINT_DELETE_RATE_GROUP}/${id}`)
    .then(response => response)
    .catch(error => error);
}

export const getRateGroupSegments = async (id: number) => {
  return apiHttpClient().get<RateGroupSegment[]>(`${ENDPOINT_GET_RATE_GROUP_SEGMENTS}/${id}`)
    .then(response => response)
    .catch(error => error);
}

export const listRelationsOfRateGroup = async (request: ListRelationsOfRateGroupRequest) => {
  return await apiHttpClient().post<PaginationItems<ListRelationsOfRateGroupModel>>(ENDPOINT_LIST_RELATIONS_OF_RATEGROUP, request)
    .then(response => {
      return response;
    })
    .catch(error => {
      return error;
    })
}